// Percorso file: src/pages/home/HomePending.jsx
//
// VISTA D'ATTESA — status PENDING (diario, CONTRATTO punto 3:
// «Un utente PENDING può fare login ma vede SOLO una schermata
// d'attesa — nessuna funzione»).
//
// Non offre nessuna azione oltre al Logout della barra utente: lo stato
// lo cambia sempre e solo un ADMIN/SUPERADMIN, con azione esplicita.
// È un vicolo cieco, quindi accende `showLogout` (cantiere LOGOUT-1, vedi
// UserBar.jsx): senza, dalla pagina non si uscirebbe.
//
// L'accesso alla pagina è deciso da RequireRole in App.jsx
// (`status="PENDING"`): chi non è PENDING viene rimandato
// all'instradatore.

import React from "react";
import HomeShell from "../../components/HomeShell";

const HomePending = () => (
  <HomeShell showLogout>
    <h1 className="qpsc-page-title">Enrolment received</h1>
    <p className="qpsc-body-text">
      Thank you: your enrolment has been received. A club officer will
      assign your team and your functions.
    </p>
    <p className="qpsc-body-text qpsc-body-text--muted">
      You will see your home page as soon as your account is activated.
      There is nothing else to do for now.
    </p>
  </HomeShell>
);

export default HomePending;
